import { Tag, Typography } from "antd";
import { capitalizeFirstLetter } from "../../treasury.config";
import { Util } from "../helper/helper";
const { Text, Link, Title, Paragraph } = Typography;
export default function PreviewTable({ data }) {
  return (
    <div
      style={{
        border: "1px solid #EAECF0",
        borderRadius: 12,
        overflow: "hidden",
      }}
    >
      {data?.map((item, i) => {
        return (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              border: "",
              borderBottom: i !== data.length - 1 ? "1px solid #EAECF0" : "0",
              fontWeight: 600,
              fontSize: 14,
            }}
          >
            <div
              style={{
                padding: "16px 24px",
                backgroundColor: "#F9FAFB",
                paddingInline: 25,
                paddingBlock: 12,
                fontWeight: "500",
                borderRight: "1px solid #f0f0f0",
              }}
            >
              {item.name}
            </div>
            <div style={{ paddingInline: 25, paddingBlock: 12 }}>
              {!item.type ? (
                <Tag
                  style={{
                    color: "#9F1AB1",
                    backgroundColor: "#FDF4FF",
                    borderColor: "#F6D0FE",
                    borderRadius: 9999,
                    paddingInline: 12,
                    paddingBlock: 2,
                    fontSize: 14,
                    fontWeight: 600,
                    // paddingBlock: 1,
                  }}
                >
                  {capitalizeFirstLetter(item?.labelValue)}
                </Tag>
              ) : item.type === 1 ? (
                <Text>
                  {item?.prefix ?? ""}{" "}
                  {typeof item?.labelValue === "number" ||
                  !isNaN(Number(item?.labelValue))
                    ? Number(item?.labelValue).toLocaleString()
                    : Util.capitalizeFirstLetter(item?.labelValue)}
                  {item?.suffix ?? ""}{" "}
                </Text>
              ) : item.type === 2 ? (
                <Tag
                  style={{
                    color: "#9F1AB1",
                    backgroundColor: "#FDF4FF",
                    borderColor: "#F6D0FE",
                    borderRadius: 9999,
                    paddingInline: 12,
                    paddingBlock: 2,
                    fontSize: 14,
                    fontWeight: 600,
                    // paddingBlock: 1,
                  }}
                >
                  {capitalizeFirstLetter(item?.labelValue ? "Yes" : "No")}
                </Tag>
              ) : (
                item.type === 3 && (
                  <div style={{}}>
                    {item.items.map((items, index) => {
                      if (items?.type === 1)
                        return (
                          <Text style={{ paddingInline: 12 }}>
                            {items?.prefix ?? ""}{" "}
                            {Util.capitalizeFirstLetter(items?.labelValue)}
                            {items?.suffix ?? ""}{" "}
                          </Text>
                        );
                      else if (items?.labelValue)
                        return (
                          <Tag
                            key={index}
                            style={{
                              color: "#9F1AB1",
                              backgroundColor: "#FDF4FF",
                              borderColor: "#F6D0FE",
                              borderRadius: 9999,
                              paddingInline: 12,
                              paddingBlock: 2,
                              fontSize: 14,
                              fontWeight: 600,
                              marginBlock: 5,
                              // paddingBlock: 1,
                            }}
                          >
                            {capitalizeFirstLetter(items?.labelValue)}
                          </Tag>
                        );
                    })}
                  </div>
                )
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
